import React from 'react';
import { Chip, Icon } from '@hai/ui-react';
import { useTranslation } from 'react-i18next';
import { StreamViewModel } from './stream/stream-models';
import { VideoEncoderViewModel } from './video-encoder/video-encoder-models';

interface HeaderStatsRowProps {
  data: StreamViewModel | VideoEncoderViewModel;
  classPrefix: string; // 'stream' or 'decoder'
}

function isStreamViewModel(data: any): data is StreamViewModel {
  return 'protocol' in data;
}

const HeaderStatsRow: React.FC<HeaderStatsRowProps> = ({ data, classPrefix }) => {
  const { t } = useTranslation();

  return (
    <div className={`${classPrefix}-stats-row d-flex justify-content-end text-right`}>
      <div className={`${classPrefix}-stat-group`}>
        <div className="stat-label">{t('statistics.header.statisticsInformation.id')}</div>
        <Chip size="sm" className="stat-value">
          {data?.id ?? 'N/A'}
        </Chip>
      </div>
      {isStreamViewModel(data) && (
        <div className={`${classPrefix}-stat-group`}>
          <div className="stat-label">{t('statistics.header.statisticsInformation.type')}</div>
          <div className="stat-value">
            {data?.encapsulationTextual?.includes('SRT') ? (
              <Icon iconname="BadgeStreamSRT" />
            ) : data?.encapsulationTextual?.includes('UDP') ? (
              <Icon iconname="BadgeStreamUDP" />
            ) : data?.encapsulationTextual?.includes('RTP') ? (
              <Icon iconname="BadgeStreamRTP" />
            ) : (
              t('statistics.header.statisticsInformation.unknown')
            )}
          </div>
        </div>
      )}
      <div className={`${classPrefix}-stat-group`}>
        <div className="stat-label">{t('statistics.header.statisticsInformation.status')}</div>
        <div className="stat-value">{data?.stats.state ?? t('statistics.header.statisticsInformation.unknown')}</div>
      </div>
      <div className={`${classPrefix}-stat-group`}>
        <div className="stat-label">{t('statistics.header.statisticsInformation.uptime')}</div>
        <div className="stat-value">{data?.stats?.uptime ?? '0s'}</div>
      </div>
      <div className={`${classPrefix}-stat-group`}>
        <div className="stat-label">{t('statistics.header.statisticsInformation.lastReset')}</div>
        <div className="stat-value">{data?.stats?.lastReset ?? 'N/A'}</div>
      </div>
    </div>
  );
};

export { HeaderStatsRow };
